import { IconV1 } from 'common/icon/iconV1.js';
import { useAppSelector } from 'redux-state/configure-store.js';
import { IRepoState } from 'redux-state/rootReducer.js';

/** Displays loading icons whilst waiting for page payload */
export const PageLoader = ({ children }: { children?: JSX.Element }) => {
  const isLoading = useAppSelector((state: IRepoState) => state.LOADING.isLoading);
  if (isLoading) {
    /** Add vh as we want the blue bouncing animation to take up most of the page */
    return (
      <div className="pageLoader" style={{ height: '82vh' }}>
        <div className="pageLoader-animation">
          <div className="pageLoader-animation-main">
            <div className="load-dot-one">
              <IconV1 icon="condition-cloudy" size={50} />
            </div>
            <div className="load-dot-two">
              <IconV1 icon="condition-fine" size={50} />
            </div>
            <div className="load-dot-three">
              <IconV1 icon="condition-thunder" size={50} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return children;
};
